import gql from "graphql-tag";
import type {
  GeneratedMutation,
  GraphQLResult,
} from "@aws-amplify/api-graphql";
import type { VerifyInsuranceInput, VerifyInsuranceResponse } from "@rmh/defs";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { fetchGraphQLClient } from "@rmh/data-ops/src/amplify/fetchGraphQLClient";

export const verifyInsuranceMutation = gql`
  mutation VerifyInsurance($input: VerifyInsuranceInput!) {
    verifyInsurance(input: $input) {
      success
      error
      errorType
      data {
        copay
        initialCost
        reAssessmentCost
        verifiedFor
        deductible {
          individual
          family
        }
      }
    }
  }
`.loc?.source.body as GeneratedMutation<
  { input: VerifyInsuranceInput },
  { verifyInsurance: VerifyInsuranceResponse }
>;

export const useVerifyEligibility = (
  options?: UseMutationOptions<
    GraphQLResult<{ verifyInsurance: VerifyInsuranceResponse }>,
    Error,
    VerifyInsuranceInput
  >
) =>
  useMutation({
    mutationFn: async (input: VerifyInsuranceInput) =>
      fetchGraphQLClient(verifyInsuranceMutation, { input }),
    ...options,
  });
